// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { openMPView } from '../actions/routes';
import MPBanner from '../components/MPBanner';
import { selectIsMPEnabled } from '../selectors/computed/runtime';
import { selectMPGlobalStatus } from '../selectors/global';
import MPBannerSelectors from '../selectors/specifics/MPBannerSelectors';
import { MPGlobalStatuses } from '../types/global';

type MPBannerContainerProps = {
  className?: string;
};

const MPBannerContainer = (ownProps: MPBannerContainerProps) => {
  const dispatch = useDispatch();
  const isMPEnabled = useSelector(selectIsMPEnabled);
  const globalStatus = useSelector(selectMPGlobalStatus);

  const backgroundPath = useSelector(MPBannerSelectors.selectBackgroundPath);
  const status = useSelector(MPBannerSelectors.selectBannerStatus);

  const selectedProps = useMemo(
    () => ({
      backgroundPath,
      status,
    }),
    [backgroundPath, status],
  );

  const onClick = useCallback(
    (e) => {
      if (e) {
        e.stopPropagation();
      }

      dispatch(openMPView());
    },
    [dispatch],
  );

  const otherProps = useMemo(
    () => ({
      onClick,
    }),
    [onClick],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return isMPEnabled && globalStatus === MPGlobalStatuses.RUNNING ? <MPBanner {...enhancedProps} /> : null;
};

export default MPBannerContainer;
